import React from "react";
import { Tabs } from "antd";
import CityTab from "./city";
import StateTab from "./state";
import CountryTab from "./country";

const { TabPane } = Tabs;
const LocationManager = () => {
  const tabStyle = {
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 500,
    marginLeft: "5px",
  };

  return (
    <div style={{ padding: "4px" }}>
      <Tabs
        defaultActiveKey="country"
        destroyInactiveTabPane={true}
        type="line"
        tabBarStyle={{
          marginBottom: 12,
          borderBottom: "1px solid #f0f0f0",
        }}
      >
        <TabPane tab={<span style={tabStyle}>Country</span>} key="country">
          <CountryTab />
        </TabPane>
        <TabPane tab={<span style={tabStyle}>State</span>} key="state">
          <StateTab />
        </TabPane>
        <TabPane tab={<span style={tabStyle}>City</span>} key="city">
          <CityTab />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default LocationManager;
